import type { LinkProps } from '@ps/web-shared-components';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { SVGAttributes } from 'react';
import React from 'react';

import type { GameView } from '../../types/common';

import styles from './GridListViewToggleButton.scss';

export interface Props {
  id: string;
  selected?: boolean;
  gameView: GameView;
  handleSelect?(selected: GameView): void;
  linkProps?: LinkProps;
  classes?: {
    button?: string;
    active?: string;
  };
  icon: React.ReactElement<SVGAttributes<SVGElement>, React.FC<SVGAttributes<SVGElement>>>;
}

const GridListViewToggleButton: React.FC<Props> = ({
  id,
  gameView,
  selected,
  handleSelect,
  linkProps,
  classes,
  icon
}) => {
  const buttonClassName = [styles.button, classes?.button];
  const activeClassName = classNames(styles.active, classes?.active);

  return (
    <div
      data-testid={`${id}-${gameView}`}
      className={classNames(buttonClassName, {
        [activeClassName]: selected
      })}
      onClick={() => handleSelect?.(gameView)}
    >
      {linkProps && (
        <Link className={styles.link} {...linkProps}>
          {icon}
        </Link>
      )}
      {!linkProps && icon}
    </div>
  );
};
export default GridListViewToggleButton;
